import * as Yup from 'yup';
import {MNullable} from '../Toolkit/Utils';

export class Contact {
    public static readonly ContactNameMaxLength = 50;
    public static readonly ContactEmailMaxLength = 255;

    public id: number = 0;
    public contactType: number = 0;
    public contactName: string = '';
    public contactEmail: string = '';
}

export class CreateContactValidator {
    public static readonly contactType = Yup.number().required();
    public static readonly contactName = Yup.string().max(Contact.ContactNameMaxLength).required();
    public static readonly contactEmail = Yup.string().max(Contact.ContactEmailMaxLength).required();
}

export class UpdateContactValidator {
    public static readonly contactType = Yup.number().required();
    public static readonly contactName = Yup.string().max(Contact.ContactNameMaxLength).required();
    public static readonly contactEmail = Yup.string().max(Contact.ContactEmailMaxLength).required();
}

export class ContactReply {
    public contact: MNullable<Contact> = null;
}

export class ContactReplyMulti {
    public contacts: Contact[] = [];
}